import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import tiendaImg from './images/tienda112.png';
import cofreImg from './images/cofre100.png';
import biruxBronce112 from './images/biruxBronce112.png';
import biruxOro112 from './images/biruxOro112.png';
import biruxComodin112 from './images/biruxComodin112.png';
import GeneralPopUp from './components/generalPopUp';
import Spinner from './components/Spinner';
import { useTutorial } from './components/Tutorial';

const currencyInfo = {
  birux: { label: 'birux de bronce', img: biruxBronce112, enOverbox: true },
  biruxComodin: { label: 'birux comodín', img: biruxComodin112, enOverbox: true },
  biruxOro: { label: 'birux de oro', img: biruxOro112, enOverbox: false },
  biruxPlata: { label: 'birux de plata', img: false, enOverbox: false }
}
// reward.type -> moneda (la misma tabla que CURRENCY_FIELDS de apps/apps.js)
const currencyByType = { 0: 'birux', 1: 'biruxComodin', 3: 'biruxPlata', 4: 'biruxOro' };

// Lo que ha pasado al usarla, si su funcion lo cuenta (apps/rewardFunctions.js).
const resultInfo = {
  vip_won: { title: '¡Eres VIP!', description: '¡Te ha tocado! Ya eres VIP del canal de Twitch.' },
  vip_lost: { title: 'Sin suerte', description: 'Esta vez no ha tocado el VIP de Twitch. ¡Prueba otra vez!' }
}

const Rewards = ({ userPlayer, authPlatform, type, handleAuth, setIsDropped, setOverInfo }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const urlSearch = searchParams.get('search') || '';
  const [searchReward, setReward] = React.useState(urlSearch);
  const [rewards, setRewards] = React.useState(['']);
  const [showPopUp, setShowPopUp] = React.useState(false);
  const [rewardToBuy, setRewardToBuy] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [submitting, setSubmitting] = React.useState(false);
  // El filtro de oro solo viene marcado si el usuario tiene birux de oro: si no
  // tiene, la tienda arranca sin recompensas de oro (puede activarlas a mano).
  const [currencyFilter, setCurrencyFilter] = React.useState(() => ({
    0: true, 1: true, 4: !!(userPlayer && userPlayer.biruxOro > 0)
  }));
  const goldFilterDecidedRef = React.useRef(!!userPlayer);
  const pendingScrollRef = React.useRef(null);
  const scrollKey = 'rewardsScrollY';
  // Pasos del tutorial en la tienda (components/Tutorial.jsx): el Pase Plus solo se enseña, el filtro
  // de bronce deja solo el bronce y en 'compra' solo salen las que paga con el premio. Al abrir el
  // Pase Plus y al pulsar el filtro se le avisa para que siga.
  const tutorial = useTutorial();
  const paso = tutorial && tutorial.paso;
  // El ?search= de la URL puede cambiar sin que el componente se vuelva a montar
  // (deep-link estando ya en la tienda, o volver al menú "Tienda" sin query).
  React.useEffect(() => {
    setReward(urlSearch);
  }, [urlSearch])

  React.useEffect(() => {
    getRewards();
  }, [searchReward])

  // userPlayer llega de forma asíncrona. Si al montar aún no estaba, ajustamos el
  // filtro de oro una única vez: nunca pisamos una elección manual del usuario.
  React.useEffect(() => {
    if (goldFilterDecidedRef.current || !userPlayer) return;
    goldFilterDecidedRef.current = true;
    setCurrencyFilter(prev => ({ ...prev, 4: userPlayer.biruxOro > 0 }));
  }, [userPlayer])

  React.useEffect(() => {
    const saved = sessionStorage.getItem(scrollKey);
    if (saved !== null) {
      pendingScrollRef.current = parseInt(saved, 10);
      sessionStorage.removeItem(scrollKey);
    }
  }, []);

  React.useEffect(() => {
    if (pendingScrollRef.current !== null && !loading) {
      window.scrollTo(0, pendingScrollRef.current);
      pendingScrollRef.current = null;
    }
  }, [loading]);

  const getRewards = async () => {
    let url = '/api/rewards?search=' + searchReward;
    if (userPlayer && type === 'rewards') {
      url += '&userid=' + encodeURIComponent(userPlayer._id);
    }
    let rewardsList = await fetch(url, { method: 'POST' });
    let rewardsListDef = await rewardsList.json()
    setRewards(rewardsListDef);
    setLoading(false);
  };

  const handleSearch = (event) => {
    setReward(event.target.value);
  }

  const toggleCurrency = (currencyType) => {
    if (paso === 'filtro' && currencyType === 0) {
      setCurrencyFilter({ 0: true, 1: false, 4: false });
      tutorial.avisar('filtro');
      return;
    }
    if (currencyType === 4) goldFilterDecidedRef.current = true;
    setCurrencyFilter(prev => ({ ...prev, [currencyType]: !prev[currencyType] }));
  }

  const openPopUp = (reward) => {
    const rewardTo = {
      title: (type === 'rewards' ? 'Usar -' : 'Comprar -') + (reward.name ? ' ' + reward.name : ''),
      description: type === 'rewards' ? '¿Qué quieres hacer con esta recompensa?' : '¿Quieres comprar esta recompensa?',
      reward: reward._id,
      sell: type === 'rewards' ? {
        prices: reward.sellPrices || [],
        sellable: reward.sellable,
        paid: reward.sellPaid,
        until: reward.sellUntil,
        current: reward.price,
        quantity: reward.quantity,
        ...(currencyInfo[currencyByType[reward.type]] || currencyInfo.birux)
      } : null,
      requiresText: !!reward.requiresText,
      textLabel: reward.text,
      textExample: reward.example
    }
    setRewardToBuy(rewardTo);
    setShowPopUp(true);
    if (paso === 'tarjeta' && reward._id === tutorial.premios.pase.id) tutorial.avisar('tarjeta');
  }

  const noTeLlega = (currencyField) => {
    const currency = currencyInfo[currencyField] || currencyInfo.birux;
    return {
      title: 'No tienes suficientes',
      description: <span className='popUpTextLine'>Te faltan {currency.img ? <img src={currency.img} alt={currency.label} /> : ''} {currency.label} para {type === 'rewards' ? 'usar' : 'comprar'} esta recompensa.</span>,
      ...(currency.enOverbox ? {
        button: () => {
          setIsDropped(false);
          navigate('/myAccount/overbox');
        },
        buttonText: <><h3>Conseguir más</h3></>,
        buttonClass: 'heroe'
      } : {})
    };
  }

  const buyReward = async (reward, buyType, userText) => {
    if (submitting) return;
    // Tutorial: el Pase Plus nunca se compra, aunque le llegue. Sin comodines sale el aviso de siempre.
    if (paso === 'comprar' && tutorial.premios.pase && reward.reward === tutorial.premios.pase.id) {
      setRewardToBuy('');
      setShowPopUp(false);
      if (!tutorial.leLlega) {
        setOverInfo(noTeLlega('biruxComodin'));
        setIsDropped(true);
      }
      tutorial.avisar('pase');
      return;
    }
    setSubmitting(true);
    try {
      let url = '/api/rewards';
      let action = type === 'rewards' ? 'use' : 'buy';
      let actionType = buyType === 2 ? '&actionType=buyanduse' : '';
      if (userPlayer) {
        url += '?userid=' + encodeURIComponent(userPlayer._id) + '&action=' + action + actionType;
      }
      let rewardToBuy = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          reward: reward.reward,
          userText: userText || ''
        })
      });
      let rewardToBuyRes = await rewardToBuy.json();
      if (rewardToBuyRes.success && !rewardToBuyRes.error) {
        const result = resultInfo[rewardToBuyRes.result];
        setIsDropped(!!result);
        setOverInfo(result || false);
        sessionStorage.setItem(scrollKey, String(window.scrollY));
        handleAuth();
        getRewards();
        if (tutorial) tutorial.avisar('compra');
      } else {
        const formatCooldown = (seconds) => {
          const mins = Math.floor(seconds / 60);
          const secs = seconds % 60;
          return mins > 0 ? `${mins} minuto${mins !== 1 ? 's' : ''} y ${secs} segundo${secs !== 1 ? 's' : ''}` : `${secs} segundo${secs !== 1 ? 's' : ''}`;
        };
        if (rewardToBuyRes.error === 'limit_definitive') {
          setOverInfo({ title: 'Se han agotado!', description: 'No se pueden comprar más hasta el próximo periodo.' });
        } else if (rewardToBuyRes.error === 'user_cooldown') {
          setOverInfo({ title: 'Cooldown activo', description: `No puedes usar otra recompensa hasta dentro de ${formatCooldown(rewardToBuyRes.data)}.` });
        } else if (rewardToBuyRes.error === 'bought_but_cooldown') {
          sessionStorage.setItem(scrollKey, String(window.scrollY));
          handleAuth();
          getRewards();
          setOverInfo({ title: 'Comprada!', description: `Se ha comprado pero no podrá utilizarse hasta dentro de ${formatCooldown(rewardToBuyRes.data)}.` });
        } else if (rewardToBuyRes.error === 'game_inactive') {
          setOverInfo({
            title: 'Juego no activo',
            description: (rewardToBuyRes.data ? 'El juego ' + rewardToBuyRes.data : 'El juego de esta recompensa') +
              ' no está activo ahora mismo. ' +
              (type === 'rewards' ? 'La conservas en tu inventario y podrás usarla cuando vuelva.' : 'No se puede comprar hasta que vuelva.')
          });
        } else if (rewardToBuyRes.error === 'stream_limit') {
          // Con "Comprar y usar" la compra si se ha hecho: hay que refrescar saldo e inventario.
          sessionStorage.setItem(scrollKey, String(window.scrollY));
          handleAuth();
          getRewards();
          setOverInfo({
            title: 'Ya se ha usado en este directo',
            description: 'Esta recompensa solo se puede usar un número de veces por directo entre todos. ' +
              (type === 'rewards' ? 'La conservas' : 'Se ha comprado y la tienes') +
              ' en tu inventario para usarla cuando empiece el siguiente directo.'
          });
        } else if (rewardToBuyRes.error === 'stream_offline' || rewardToBuyRes.error === 'stream_ending') {
          // Con "Comprar y usar" la compra si se ha hecho: hay que refrescar saldo e inventario.
          sessionStorage.setItem(scrollKey, String(window.scrollY));
          handleAuth();
          getRewards();
          const offline = rewardToBuyRes.error === 'stream_offline';
          setOverInfo({
            title: offline ? 'Solo en directo' : 'El directo está terminando',
            description: (offline ? 'Esta recompensa solo se puede usar durante el directo. ' : 'Las recompensas de directo no se pueden usar en los últimos 5 minutos. ') +
              (type === 'rewards' ? 'La conservas' : 'Se ha comprado y la tienes') +
              ' en tu inventario para usarla en el siguiente directo.'
          });
        } else if (rewardToBuyRes.error === 'text_required') {
          setOverInfo({ title: 'Falta el texto', description: 'Esta recompensa necesita que escribas un texto para poder usarla.' });
        } else if (rewardToBuyRes.error === 'banned_text') {
          // Con "Comprar y usar" la compra si se ha hecho: hay que refrescar saldo e inventario.
          sessionStorage.setItem(scrollKey, String(window.scrollY));
          handleAuth();
          getRewards();
          setOverInfo({
            title: 'Texto no permitido',
            description: 'Tu mensaje lleva palabras que no se pueden decir en directo. La recompensa no se ha gastado: ' +
              (type === 'rewards' ? 'cambia el texto y vuelve a usarla.' : 'la tienes en tu inventario para usarla con otro texto.')
          });
        } else if (rewardToBuyRes.error === 'already_vip') {
          // Con "Comprar y usar" la compra si se ha hecho: hay que refrescar saldo e inventario.
          sessionStorage.setItem(scrollKey, String(window.scrollY));
          handleAuth();
          getRewards();
          setOverInfo({
            title: 'Ya eres VIP',
            description: 'Ya eres VIP o moderador del canal de Twitch, así que no te hace falta. La recompensa no se ha gastado' +
              (type === 'rewards' ? '.' : ': la tienes en tu inventario.')
          });
        } else if (rewardToBuyRes.error === 'monthly_budget_exceeded') {
          setOverInfo({ title: 'Presupuesto mensual agotado', description: 'Se ha llegado al límite mensual. Espera al mes que viene para comprar más.' });
        } else if (typeof rewardToBuyRes.error === 'string' && rewardToBuyRes.error.startsWith('Not enough ')) {
          setOverInfo(noTeLlega(rewardToBuyRes.error.slice('Not enough '.length).trim()));
        } else {
          setOverInfo({ title: 'Error', description: rewardToBuyRes.error });
        }
        setIsDropped(true);
      }
    } catch (e) {
      setOverInfo({ title: 'Error', description: 'Fallo de red.' });
      setIsDropped(true);
    } finally {
      setRewardToBuy('');
      setShowPopUp(false);
      setSubmitting(false);
    }
  }

  const sellReward = async (reward, quantity) => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const res = await (await fetch('/api/rewards?action=sell', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reward: reward.reward, quantity })
      })).json();
      if (res.success) {
        const currency = currencyInfo[res.currency] || currencyInfo.birux;
        setOverInfo({
          title: res.sold > 1 ? '¡Vendidas ' + res.sold + '!' : '¡Vendida!',
          description: <span className='popUpTextLine'>{res.sold < quantity ? 'Solo se podían vender ' + res.sold + '. ' : ''}Te hemos dado {res.amount} {currency.img ? <img src={currency.img} alt={currency.label} /> : currency.label}.</span>
        });
        sessionStorage.setItem(scrollKey, String(window.scrollY));
        handleAuth();
        getRewards();
      } else {
        setOverInfo({ title: 'Error', description: res.error === 'no_reward' ? 'No te queda ninguna de esta que se pueda vender.' : 'No se ha podido vender.' });
        getRewards();
      }
    } catch (e) {
      setOverInfo({ title: 'Error', description: 'Fallo de red.' });
    } finally {
      setIsDropped(true);
      setRewardToBuy('');
      setShowPopUp(false);
      setSubmitting(false);
    }
  }

  return (
    <div className="topCommands commandsBox page">
      {showPopUp && <GeneralPopUp popUpData={rewardToBuy} isShop={type} onClose={() => setShowPopUp(false)} buyFunction={(buyType, userText) => buyReward(rewardToBuy, buyType, userText)} sellFunction={type === 'rewards' ? (quantity) => sellReward(rewardToBuy, quantity) : undefined} submitting={submitting} soloComprar={paso === 'compra'} />}
      <div className='titlePage'><img src={type === 'shop' ? tiendaImg : cofreImg} alt={type === 'shop' ? 'Tienda' : 'Inventario'} />
        <h1 className='heroes'>{type === 'shop' ? 'Tienda' : type === 'rewards' ? 'Recompensas' : ''}</h1>
      </div>
      {type === 'shop' && <div className="currencyFilter">
        <button className={'currencyFilterBtn' + (currencyFilter[0] ? ' active' : '')} onClick={() => toggleCurrency(0)}>
          <img src={biruxBronce112} alt="Birux Bronce" />
        </button>
        <button className={'currencyFilterBtn' + (currencyFilter[1] ? ' active' : '')} onClick={() => toggleCurrency(1)}>
          <img src={biruxComodin112} alt="Birux Comodín" />
        </button>
        <button className={'currencyFilterBtn' + (currencyFilter[4] ? ' active' : '')} onClick={() => toggleCurrency(4)}>
          <img src={biruxOro112} alt="Birux Oro" />
        </button>
      </div>}
      <input className="userSearch" placeholder="Busca una recompensa" type="text" value={searchReward} onChange={handleSearch}></input>
      <div className="infoBox">
        {rewards.length === 0 ? (
          <div className="heroes">No se ha encontrado ninguna recompensa.</div>
        ) : loading ? <Spinner /> : (rewards.filter(reward => type !== 'shop' || currencyFilter[reward.type ?? 0])
          // El VIP solo existe en Twitch: la Tirada VIP solo la ve quien ha entrado con Twitch.
          .filter(reward => reward.fn !== 'vipTwitch' || authPlatform === 'twitch')
          .filter(reward => type !== 'shop' || paso !== 'compra' || (!reward.type && reward.price <= tutorial.premios.bronce)).map(reward => (
          <div data-reward={reward._id} className={reward.karmaType && reward.karmaType != 0 ? (
            reward.karmaType === 1 ? 'heroesBox zoom' : 'villanoBox zoom'
          ) : ''} onClick={() => openPopUp(reward)}>
            <img className='rewardImage' src={'/images/rewards/' + reward.image}></img>
            <div className='heroes'>
              <h3 className='name'>{reward.name}</h3>
              <div className='description'>{reward.description}</div>
              <div className='commandRow'>
                <div>
                  <div>Recompensa: {reward.karmaType && reward.karmaType != 0 ? (
                    reward.karmaType === 1 ? 'Heroe' : 'Villano'
                  ) : 'Neutro'} </div>
                  <div>Juego: {reward.game}</div>
                </div>
                <div className='commandRow'>
                  {type == 'shop' ? <div>Precio: {reward.price} {reward.type === 1 ? <img src={biruxComodin112}></img> : !reward.type || reward.type == 0 ? <img src={biruxBronce112}></img> : <img src={biruxOro112}></img>}</div> : ''}
                  <div>Enfriamiento: {reward.cooldown}</div>
                  {reward.streamLimit > 0 ? <div>Usos por directo (entre todos): {reward.streamLimit}</div> : ''}
                  {reward.streamReward ? <div>Solo en directo (no en los últimos 5 min)</div> : ''}
                  <div>{type == 'rewards' ? 'Cantidad: ' + reward.quantity : ''}</div>
                </div>
              </div>
            </div>
          </div>
        )))}
      </div>
    </div>
  )
}

export default Rewards
